export default __webpack_public_path__ + "static/media/grafema_2ndliferesin_13.660909d8.jpg";